<template>
    <main class="home tw-bg-cover tw-bg-center">
        <header class="lg:tw-py-2">
            <div class="tw-container tw-flex tw-items-center tw-justify-center tw-py-2">
                <img src="~@/assets/img/logo.svg" alt="">
            </div>
        </header>
        <section class="hero tw-flex tw-flex-col tw-items-center tw-justify-center lg:tw-flex-row lg:tw-items-start lg:tw-justify-between tw-h-full">
            <div class="info-container">
                <div class="text">
                    <h1>
                        OIÇA e PERCEBA <br>todas as conversas!
                    </h1>
                    <h2>
                        Aparelhos auditivos quase invisíveis
                    </h2>
                </div>
            </div>
            <div class="form-container">
                <img src="~@/assets/img/icons/form-icon.svg">
                <Form v-if="!$store.state.formSuccess" />
                <FormSuccess v-if="$store.state.formSuccess" />
            </div>
        </section>
        <section class="device">
            <div class="tw-container">
                <h2>ampli-mini</h2>
                <h3>Aparelhos auditivos dentro do ouvido (ITE)</h3>
                <div class="content tw-grid tw-grid-cols-1 lg:tw-grid-cols-2 tw-gap-5">
                    <div class="text">
                        <ul>
                            <li>
                                <h4>Discretos</h4>
                                <p>Dentro do canal auditivo para ninguém ver</p>
                            </li>
                            <li>
                                <h4>Clareza nos 2 ouvidos</h4>
                                <p>Tecnologia para Perceber Bem todas as conversas</p>
                            </li>
                            <li>
                                <h4>Fáceis de usar</h4>
                                <p>Ajustam-se aos diferentes ambientes sonoros</p>
                            </li>
                        </ul>
                    </div>
                    <img src="~@/assets/img/content-desktop.png" class="tw-hidden lg:tw-block">
                    <img src="~@/assets/img/content-mobile.png" class="tw-block lg:tw-hidden">
                </div>
                <button class="btn-page tw-block tw-mx-auto tw-mt-10 lg:tw-mt-16" v-scroll-to="'.form-container'">
                    Marcar Consulta Gratuita
                </button>
            </div>
        </section>
        <section class="about">
            <div class="tw-container">
                <div class="tw-flex tw-flex-col tw-items-center tw-justify-items-center tw-gap-6 lg:tw-flex-row lg:tw-gap-20">
                    <img src="~@/assets/img/badges.png">
                    <div class="text">
                        <h3>Somos “Escolha do Consumidor” e “Marca de Confiança”</h3>
                        <p>O prémio “Escolha do Consumidor 2024” e a distinção “Marca de Confiança 2024” são um voto de confiança que comprovam o valor que a marca Minisom já conquistou em Portugal na área da reabilitação auditiva.</p>
                    </div>
                </div>
            </div>
        </section>
        <footer>
            <div class="tw-container">
                <p>
                    Oferta válida na aquisição de 2 aparelhos auditivos da gama Excellence, no período de 1 a 31/10/2024. Não acumulável com outras promoções em vigor.
                </p>
                <p>
                    A Amplifon Portugal S.A. presta serviços de saúde na área da audiologia e reabilitação auditiva, sendo os seus centros auditivos registados na Entidade Reguladora da Saúde (nº 26950) e os seus técnicos de diagnóstico audiologistas com cédula profissional emitida pela Administração Central do Sistema de Saúde.
                </p>
                <p>
                    A Amplifon Portugal S.A. disponibiliza nos seus centros auditivos serviços de saúde de reabilitação auditiva com recurso a aparelhos auditivos, que são dispositivos médicos. Deve sempre ler atentamente a rotulagem e as instruções de utilização dos dispositivos médicos. Os aparelhos auditivos são parte da habilitação auditiva e podem precisar ser complementados com treino auditivo e leitura labial e devem ser utilizados apenas conforme orientado e ajustados por um técnico especializado em aparelhos auditivos. A utilização indevida pode resultar em perda auditiva repentina e permanente. Perigo de asfixia e risco de ingerir pilhas e outras peças pequenas. Para mais informações ligue 800 206 740 (chamada gratuita).
                </p>
            </div>
        </footer>
    </main>
</template>
<script>
import Form from '@/components/Form.vue';
import FormSuccess from '@/components/FormSuccess.vue';

export default {
    name: 'Home',
    components: {
        Form,
        FormSuccess,
    },
    data() {

        return {
        }
    },
    methods: {
    },
    mounted() {
    },
};
</script>
